export default "__VITE_ASSET__cbd47a21__"